//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Section',
  props: {
    orderDetails: { type: Object, required: false },
    sectionTitle: { type: String, required: false },
    sectionValue: { type: String, required: false },
    section: { type: String, required: false },
    icon: { type: String, required: true },
    lastSection: { type: Boolean, default: false },
    hideTextValue: { type: Boolean, default: false },
  },
};
